import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AdvancedTableSelectPopupActionButtonsProps as Props } from './types';

export const AdvancedTableSelectPopupActionButtons = memo(
  ({
    className,
    onApply,
    onClear,
    disabledSubmitButton,
    disabledClearButton,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames(
          'AdvancedTableSelectPopupActionButtons',
          className
        )}
        sx={SX.root}
      >
        <Styled.ActionButton
          size="small"
          variant="text"
          color="error"
          disabled={disabledClearButton}
          onClick={onClear}
        >
          Clear All
        </Styled.ActionButton>

        <Styled.ActionButton
          variant="contained"
          color="primary"
          size="small"
          disabled={disabledSubmitButton}
          onClick={onApply}
        >
          Apply Selection
        </Styled.ActionButton>
      </Styled.Wrapper>
    );
  }
);

AdvancedTableSelectPopupActionButtons.displayName =
  'AdvancedTableSelectPopupActionButtons';
